export default __webpack_public_path__ + "static/media/Ex.85d14b66.png";